import React from 'react';
import {observer} from 'mobx-react';
import {LayeredImageController} from './LayeredImageController';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';

interface LayeredImageComponentProps {
    layeredImageController: LayeredImageController;
    className?: string;
    onClick?: (e: React.MouseEvent) => void;
    children: React.ReactNode;
    canvasClassName?: string;
}

@observer
export class LayeredImageComponent extends TechseeBaseComponent<LayeredImageComponentProps> {
    private containerRef = React.createRef<HTMLDivElement>();
    private canvasContainerRef = React.createRef<HTMLDivElement>();

    componentDidMount(): void {
        this.updateCanvases();
    }

    componentDidUpdate(): void {
        this.updateCanvases();
    }

    private updateCanvases(): void {
        const {layeredImageController, canvasClassName = 'layered-image-canvas'} = this.props;
        const container = this.canvasContainerRef.current;

        if (!container) return;

        if (this.containerRef.current) {
            layeredImageController.setContainer(this.containerRef.current);
        }

        const canvases = layeredImageController.getAllCanvases(canvasClassName);

        container.innerHTML = '';
        canvases.forEach((canvas) => {
            container.appendChild(canvas);
        });

        canvases.forEach((canvas) => {
            const layerId = canvas.getAttribute('data-layer-id');
            if (layerId) {
                const layer = layeredImageController.getLayer(layerId);
                if (layer) {
                    layer.invalidate();
                }
            }
        });
    }

    renderInternal(): JSX.Element {
        const {className, onClick, children, layeredImageController} = this.props;

        layeredImageController.getVisibleLayers();

        return (
            <div ref={this.containerRef} className={className} onClick={onClick}>
                {children}
                <div ref={this.canvasContainerRef} />
            </div>
        );
    }
}
